class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      document.querySelector('cart-drawer-items').updateQuantity(this.dataset.index, 0);
      // this.closest('cart-drawer-items').updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartRemoveBundleButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      document.querySelector('cart-drawer-items').removeBundle(this.dataset.index, this.getAttribute('data-keys-to-remove'));
    });
  }
}

customElements.define('cart-remove-bundle-button', CartRemoveBundleButton);

class CartRemoveB2bVariantsButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      document.querySelector('cart-drawer-items').removeBundle(this.dataset.index, this.getAttribute('data-keys-to-remove'));
    });
  }
}

customElements.define('cart-remove-b2b-variants-button', CartRemoveB2bVariantsButton);

class CartCloseButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      document.querySelector('cart-drawer').close();
    });
  }
}

customElements.define('cart-close-button', CartCloseButton);

class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.cartIcon = document.querySelector('cart-icon');
    // this.cartDrawer = document.getElementById('cart-drawer');
    this.onBodyClick = this.handleBodyClick.bind(this);
    this.addEventListener('keyup', event => event.code.toUpperCase() === 'ESCAPE' && this.close());
    this.countdownCookieName = this.getAttribute('data-countdown-cookie-name');

    swipedetect(this, function(swipedir){
      if(swipedir=='right'){
        this.close();
      }
    }.bind(this))
  }

  open() {
    if (this.cartIcon.isActive()) {
      this.setAttribute('open', true);
      // this.cartDrawer.addEventListener('transitionend', () => {
      //   this.cartDrawer.focus();
      //   trapFocus(this.cartDrawer);
      // }, { once: true });
      document.body.addEventListener('click', this.onBodyClick);
      document.dispatchEvent(new Event('view_cart'));
    }
  }

  close() {
    this.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClick);
    this.cartIcon.close();
    // removeTrapFocus(this.cartDrawer);
  }

  handleBodyClick(event) {
    const target = event.target;
    if (target !== this.cartDrawer && target !== this.cartIcon && !this.cartIcon.contains(target) && !target.closest('#cart-drawer')) {
      this.close();
    }
  }

  getSectionsToRender(parsedState, cartActionType = null) {
    if (parsedState && parsedState.item_count > 0 && cartActionType != "add") {
      /* on in-cart changes like +/-/remove */
      return [
        {
          section: 'cart',
          id: 'cart-drawer',
          selector: '.cart-drawer__heading'
        },
        {
          section: 'cart',
          id: 'cart-drawer',
          selector: '.cart-drawer-totals'
        },
        {
          section: 'cart',
          id: 'cart-drawer',
          selector: '.cart-drawer-line-items'
        },
        {
          section: 'header',
          id: 'cart-icon'
        }
      ];
    }

    /* on adding new elements to cart (one or many) */
    return [
      {
        section: 'cart',
        id: 'cart-drawer',
        selector: '.cart-drawer'
      },
      // {
      //   section: 'cart-notification-button'
      // },
      {
        section: 'header',
        id: 'cart-icon'
      }
    ];

  }
  
  renderContents(parsedState, cartActionType = null) {
      // this.productId = parsedState.id;
      this.getSectionsToRender(parsedState, cartActionType).forEach((section => {
        const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
        const selector = section.selector || section.id;
        elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], selector);
      }));
      // if (this.header) this.header.reveal();
      // this.open();
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  setCookie(cname, cvalue, minutes) {
      var d = new Date();
      d.setTime(d.getTime() + (minutes * 60 * 1000));
      var expires = "expires="+d.toUTCString();
      document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }

  getCookie(cname) {
      var name = cname + "=";
      var ca = document.cookie.split(';');
      for(var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }
      return "";
  }

  setLastAddedTimestamp() {
    this.setCookie(this.countdownCookieName, new Date().toISOString(), 30 * 24 * 60) // 30 days in minutes
  }

  /*
  setActiveElement(element) {
    this.activeElement = element;
  }
  */

}

customElements.define('cart-drawer', CartDrawer);
